<div class="modal-container">
  <div class="modal-header">
    <h2 class="modal-title">Criar nova conexão</h2>
    <button mat-icon-button class="close-button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-content">
    <div class="step-content" [formGroup]="form">
      <div class="form-group">
        <text-input [textInput]="connectionNameInput" formControlName="connectionName">
        </text-input>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button-induxtry [buttonProperties]="{
        label: 'Cancelar',
        customStyle: 'secondary',
        showLabel: true
      }" (action)="onCancel()">
    </button-induxtry>

    <button-induxtry [buttonProperties]="{
        label: 'Criar',
        customStyle: 'primary',
        showLabel: true,
        loading: isLoading
      }" (action)="onCreate()">
    </button-induxtry>
  </div>
</div>